import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styles from './breadcrumbs.styl'

export default class Breadcrumbs extends Component {

  static propTypes = {
    routes: PropTypes.array.isRequired
  }

  handleCreateLink = (links, key) => ('/' + links.filter((item, index) => index < key + 1).join('/'))

  render() {
    const { routes } = this.props
    const links = routes.filter(item => item.path !== '/').map(item => item.path)

    return (
      <ul className={styles.list}>
        {links.map((item, index) => {
          const link = this.handleCreateLink(links, index)

          return (
            <li className={styles.item} key={index}>
              {index !== links.length - 1 ? <Link to={link}>{item}</Link> : <span>{item}</span>}
            </li>
          )
        })}
      </ul>
    )
  }
}
